export {default} from 'views/Clients/Clients'


// WEBPACK FOOTER //
// ./src/views/Administration/Clients.jsx